import React from "react";
import { useTranslation } from "react-i18next";

function PortfolioPageTitle() {
  const { t, i18n } = useTranslation();

  return (
    <>
      {/* Page Title */}
      <div className="page-title">
        <div className="heading">
          <div className="container">
            <div className="row d-flex justify-content-center text-center">
              <div className="col-lg-8">
                <h1 className="text-white">{t("portfolio")}</h1>
                <p className="mb-0 text-white">{t("portfolioDesc")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Page Title */}
    </>
  );
}

export default PortfolioPageTitle;
